import React, { useState } from 'react';
import _ from 'lodash';
import BodyMatchersList, { BodyMatcherItem, XmlNamespaceItem } from 'components/transactionEditor/BodyMatchersList';
import { Tab, Tabs } from 'react-bootstrap';
import i18n from '../../../../../i18n';
import RequestMatchersList, {
  RequestMatcherItem,
} from '../../../../../components/transactionEditor/RequestMatchersList';
import { title } from './RequestTab';
import { handleNameSpaceChange } from '../../../../../utils/mockServiceUtils';

interface MessagingRequestTabProps {
  state: MessagingRequestTabState;
  updateState: (state: MessagingRequestTabState) => void;
  isReadOnly?: boolean;
}

export interface MessagingRequestTabState {
  body: BodyMatcherItem[];
  legacySampleBody: string | null;
  headers: RequestMatcherItem[];
  properties: RequestMatcherItem[];
  valid: boolean;
  dirty: boolean;
  validate: ((value: string) => boolean) | null;
  [key: string]: ((...args) => void) | string | BodyMatcherItem[] | RequestMatcherItem[] | boolean | null;
}

export const emptyBodyContentFound = (bodies: BodyMatcherItem[]): boolean => {
  return bodies.some(body => !body.content);
};

const MessagingRequestTab = (props: MessagingRequestTabProps) => {
  const updateState = (field: string, value: any, ignoreDirty?: boolean) => {
    const updatedState = _.cloneDeep(props.state);
    _.set(updatedState, field, value);
    updatedState.valid =
      updatedState.headers.length > 0 || updatedState.properties.length > 0 || updatedState.body.length > 0;
    //updatedState.valid = !emptyBodyContentFound(updatedState.body);
    if (!ignoreDirty) {
      updatedState.dirty = true;
    }
    props.updateState(updatedState);
  };

  const nonEmptyListMessage = i18n.t('transactions:editor.nonEmptyListMessage');
  const [tabRequestState, setTabRequestState] = useState('body');

  return (
    <div className="bg-light p-4">
      <Tabs id="qa-tabs-request" activeKey={tabRequestState} onSelect={(key: string) => setTabRequestState(key)}>
        <Tab title={title(i18n.t('transactions:editor.headersTitle'), props.state.headers.length)} eventKey="headers">
          <RequestMatchersList
            showIsRequiredCheckbox={true}
            isReadOnly={props.isReadOnly}
            onListChange={(items: RequestMatcherItem[]) => updateState('headers', items)}
            matcherList={props.state.headers}
            id="matchers-header"
            emptyListMessage={i18n.t('transactions:editor.emptyHeaderListMessage')}
            nonEmptyListMessage={nonEmptyListMessage}
            matcherTitle={i18n.t('transactions:editor.headerMatcherTitle')}
            isWizardModal={false}
          />
        </Tab>
        <Tab
          title={title(i18n.t('transactions:editor.propertiesTitle'), props.state.properties.length)}
          eventKey="properties"
        >
          <RequestMatchersList
            showIsRequiredCheckbox={true}
            isReadOnly={props.isReadOnly}
            onListChange={(items: RequestMatcherItem[]) => updateState('properties', items)}
            matcherList={props.state.properties}
            id="matchers-properties"
            emptyListMessage={i18n.t('transactions:editor.emptyPropertyListMessage')}
            nonEmptyListMessage={nonEmptyListMessage}
            matcherTitle={i18n.t('transactions:editor.propertyMatcherTitle')}
            isWizardModal={false}
          />
        </Tab>
        <Tab title={title(i18n.t('transactions:editor.bodyTitle'), props.state.body.length)} eventKey="body">
          <BodyMatchersList
            id="body-matchers"
            isReadOnly={props.isReadOnly}
            bodyMatcherList={props.state.body}
            legacySampleBody={props.state.legacySampleBody}
            onListChange={(items: BodyMatcherItem[]) => updateState('body', items)}
            onXmlNamespaceListChange={(items: XmlNamespaceItem[]) =>
              handleNameSpaceChange(items, props.state, props.updateState)
            }
            showByDefaultOneRow={false}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default MessagingRequestTab;
